module.exports = {"platforms":[{"type":"FiniteImmobilePlatform","x":256,"y":320,"width":64,"height":128,"display":{"assetName":"temple"}},{"type":"FiniteImmobilePlatform","x":0,"y":416,"width":352,"height":64,"display":{"assetName":"temple"}},{"type":"FiniteImmobilePlatform","x":32,"y":32,"width":96,"height":384,"display":{"assetName":"temple"}},{"type":"FiniteImmobilePlatform","x":576,"y":128,"width":224,"height":64,"display":{"assetName":"temple"}}],"goal":{"x":736,"y":128},"player":{"x":160,"y":350}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/json-loader!./levels/paper-easy.json
// module id = 151
// module chunks = 0